export const STRIPE_LINK = "https://buy.stripe.com/test_bJefZj3XggNB0dF0Oz3cc00";
